import Helmet from 'react-helmet';
import { CUSTOMER_IO_SITE_ID, INTERCOM_APP_ID, SEGMENT_KEY } from 'Config';

function AnalyticsHead() {
  return (
    <Helmet>
      {/* SEGMENT */}
      <script>
        {`
          !function(){
            var analytics=window.analytics=window.analytics||[];
            if(!analytics.initialize)
              if(analytics.invoked)
                window.console&&console.error&&console.error("Segment snippet included twice.");
              else{
                analytics.invoked=!0;
                analytics.methods=[
                  "trackSubmit",
                  "trackClick",
                  "trackLink",
                  "trackForm",
                  "pageview",
                  "identify",
                  "reset",
                  "group",
                  "track",
                  "ready",
                  "alias",
                  "debug",
                  "page",
                  "once",
                  "off",
                  "on",
                  "addSourceMiddleware",
                  "addIntegrationMiddleware",
                  "setAnonymousId",
                  "addDestinationMiddleware"
                ];
                analytics.factory=function(e){
                  return function(){
                    var t=Array.prototype.slice.call(arguments);
                    t.unshift(e);
                    analytics.push(t);
                    return analytics
                  }
                };
                for(var e=0;e<analytics.methods.length;e++){
                  var key=analytics.methods[e];
                  analytics[key]=analytics.factory(key)
                }
                analytics.load=function(key,e){
                  var t=document.createElement("script");
                  t.type="text/javascript";
                  t.async=!0;
                  t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";
                  var n=document.getElementsByTagName("script")[0];
                  n.parentNode.insertBefore(t,n);
                  analytics._loadOptions=e
                };
                analytics._writeKey='${SEGMENT_KEY}';
                analytics.SNIPPET_VERSION="4.15.3";
                analytics.load('${SEGMENT_KEY}');
          }}();
        `}
      </script>

      {/* INTERCOM */}
      <script>
        {`
          window.intercomSettings = {
          api_base: "https://api-iam.intercom.io",
            app_id:'${INTERCOM_APP_ID}'
          };
          (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/${INTERCOM_APP_ID}';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
        `}
      </script>
      {/* CUSTOMER.IO (ONLY FOR IN-APP MESSAGES) */}
      <script>
        {`
          var _cio = _cio || [];
          (function() {
              var a,b,c;a=function(f){return function(){_cio.push([f].
              concat(Array.prototype.slice.call(arguments,0)))}};b=["load","identify",
              "sidentify","track","page","on","off"];for(c=0;c<b.length;c++){_cio[b[c]]=a(b[c])};
              var t = document.createElement('script'),
                  s = document.getElementsByTagName('script')[0];
              t.async = true;
              t.id    = 'cio-tracker';
              t.setAttribute('data-site-id', '${CUSTOMER_IO_SITE_ID}');
              t.setAttribute('data-use-array-params', 'true');
              t.setAttribute('data-use-in-app', 'true');
              t.src = 'https://assets.customer.io/assets/track-eu.js'
              s.parentNode.insertBefore(t, s);
          })();
       `}
      </script>
      <script
        // eslint-disable-next-line react/no-unknown-property
        SameSite="None; Secure"
        async
        src="https://static.landbot.io/landbot-3/landbot-3.0.0.js"
      />
    </Helmet>
  );
}

export default AnalyticsHead;
